import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { DndProvider } from "react-dnd";
import { Outlet, useNavigate } from "react-router-dom";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import { MsalProvider } from "@azure/msal-react";
import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";
import { useAuth, useToken } from "@app/hooks";
import { msalConfig } from "@app/api";
import { StorageKey } from "@app/constants";
import { isMobileDevice } from "@app/helpers";
import { AppProvider } from "./AppContext";

function App({ instance }: { instance: PublicClientApplication }) {
  const [cookies] = useCookies([StorageKey.AUTH_ACCESS_TOKEN]);
  const { saveTokens } = useToken();
  const { login } = useAuth();
  const navigate = useNavigate();
  // const location = useLocation();

  // useEffect(() => {

  //   if (location.pathname === "/login") {
  //     return;
  //   }

  //   if (!!cookies?.tokens) {
  //     return;
  //   }

  //   const fn = async () => {
  //     try {
  //       // If we started login with a dynamic tenant, the redirect response
  //       // will be tied to the PublicClientApplication instance that
  //       // initiated the loginRedirect. We store that tenant config in
  //       // localStorage.authTenant during login. If present, create a
  //       // matching instance and let it handle the redirect response.
  //       debugger
  //       const stored = localStorage.getItem("authTenant");
  //       if (stored) {
  //         try {
  //           const tenant = JSON.parse(stored);

  //           const dynamicMsalConfig = {
  //             auth: {
  //               clientId: tenant.clientId,
  //               authority: `${tenant.instance}/${tenant.tenantId}/`,
  //               knownAuthorities: [new URL(tenant.instance).hostname],
  //               redirectUri: process.env.REACT_APP_REDIRECT_URL,
  //             },
  //             cache: { cacheLocation: "localStorage" }
  //           };

  //           const dynamicInstance = new PublicClientApplication(dynamicMsalConfig);
  //           await dynamicInstance.initialize();

  //           const dynamicResponse = await dynamicInstance.handleRedirectPromise();
  //           if (dynamicResponse) {
  //             login(dynamicResponse);
  //             localStorage.removeItem("authTenant");
  //             navigate("/", { replace: true });
  //             return;
  //           }

  //            const currentAccounts = dynamicInstance.getAllAccounts();
  //         const hasTokens = !!cookies?.tokens;

  //         if (!currentAccounts.length && !hasTokens) {
  //           if (!["/error-account", "/404", "/login"].includes(window.location.pathname)) {
  //             navigate("/login", { replace: true });
  //           }
  //           return;
  //         }

  //         const account = currentAccounts[0];
  //         const accessTokenRequest = {
  //           scopes: [],
  //           account,
  //         };

  //         try {
  //           const accessTokenResponse = await dynamicInstance.acquireTokenSilent(accessTokenRequest);
  //           saveTokens({ token: accessTokenResponse.idToken });
  //         } catch (error) {
  //           if (error instanceof InteractionRequiredAuthError) {
  //             navigate("/login", { replace: true });
  //           }
  //         }
  //           // if no response, fall through to the default instance flow
  //         } catch (err) {
  //           console.warn("Dynamic tenant flow failed, falling back to default instance:", err);
  //           // continue with default instance handling
  //         }
  //       } else {
  //         await instance.initialize();

  //         const response = await instance.handleRedirectPromise();

  //         if (response) {
  //           login(response);
  //           return;
  //         }

  //         const currentAccounts = instance.getAllAccounts();
  //         const hasTokens = !!cookies?.tokens;

  //         if (!currentAccounts.length && !hasTokens) {
  //           if (!["/error-account", "/404", "/login"].includes(window.location.pathname)) {
  //             navigate("/login", { replace: true });
  //           }
  //           return;
  //         }

  //         const account = currentAccounts[0];
  //         const accessTokenRequest = {
  //           scopes: [],
  //           account,
  //         };

  //         try {
  //           const accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest);
  //           saveTokens({ token: accessTokenResponse.idToken });
  //         } catch (error) {
  //           if (error instanceof InteractionRequiredAuthError) {
  //             navigate("/login", { replace: true });
  //           }
  //         }
  //       }
  //     } catch (error: any) {
  //       console.error("Error in App auth flow:", error);

  //       if (error.errorMessage?.includes("AADB2C99002")) {
  //         navigate("/error-account", { replace: true });
  //       } else if (!["/error-account", "/404", "/login"].includes(window.location.pathname)) {
  //         navigate("/login", { replace: true });
  //       }
  //     }
  //   };

  //   fn();

  // }, [location.pathname, cookies, instance, login, saveTokens, navigate]);
  useEffect(() => {
    if (!!cookies?.tokens) {
      return;
    }
    const fn = async () => {
      await instance.initialize();
      instance
        .handleRedirectPromise()
        .then((response) => {
          if (response) {
            login(response);
          } else {
            const currentAccounts = instance.getAllAccounts();
            if (!currentAccounts.length) {
              instance.loginRedirect({
                scopes: [],
                ...(["/error-account", "/404"].includes(
                  window.location.pathname,
                )
                  ? { redirectStartPage: msalConfig.auth.redirectUri }
                  : {}),
              });
            } else {
              const account = currentAccounts[0];
              const accessTokenRequest = {
                scopes: [],
                account,
              };
              instance
                .acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse) => {
                  saveTokens({ token: accessTokenResponse.idToken });
                })
                .catch((error) => {
                  if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(accessTokenRequest);
                  }
                });
            }
          }
        })
        .catch((error) => {
          if (error.errorMessage.includes("AADB2C99002")) {
            navigate("/error-account");
          }
        });
    };
    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MsalProvider instance={instance}>
      <AppProvider>
        <DndProvider backend={isMobileDevice ? TouchBackend : HTML5Backend}>
          <Outlet />
        </DndProvider>
      </AppProvider>
    </MsalProvider>
  );
}

export default App;
